/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrderMenuItem,
    OrderMenuItemFromJSON,
    OrderMenuItemFromJSONTyped,
    OrderMenuItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrderMenuItemDataFrame
 */
export interface OrderMenuItemDataFrame {
    /**
     * 
     * @type {number}
     * @memberof OrderMenuItemDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OrderMenuItemDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof OrderMenuItemDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<OrderMenuItem>}
     * @memberof OrderMenuItemDataFrame
     */
    data: Array<OrderMenuItem>;
}

export function OrderMenuItemDataFrameFromJSON(json: any): OrderMenuItemDataFrame {
    return OrderMenuItemDataFrameFromJSONTyped(json, false);
}

export function OrderMenuItemDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderMenuItemDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(OrderMenuItemFromJSON)),
    };
}

export function OrderMenuItemDataFrameToJSON(value?: OrderMenuItemDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(OrderMenuItemToJSON)),
    };
}


